import { Extrato } from '../../../../pkw-data/collect/extrato/extrato.interface'
import { Transacao } from '../../../../pkw-data/collect/extrato/transacao.model'
import { OperadoraDeMaquina } from '../../../../pkw-data/collect/operadora-de-maquina.model'
import { CORES_OPERADORAS } from '../../shared/cores-operadoras.const'

export abstract class ChartPeriodoOptions {
    title: { text: string }
    extrato: Extrato<Transacao>
    colors: string[]
    series: { name: string; data: number[] }[]

    chart = {
        type: 'column',
        inverted: true
    }
    xAxis = {
        categories: []
    }
    yAxis = {
        labels: {
            format: 'R$ {value}'
        },
        title: {
            text: 'Valor em reais'
        }
    }
    credits = {
        enabled: false
    }
    plotOptions = {
        column: {
            stacking: 'normal'
        }
    }
    tooltip = {
        valuePrefix: 'R$ ',
        pointFormat: '<span><b>{point.y}</b></span>',
        valueDecimals: 2
    }

    protected operadoras: OperadoraDeMaquina[]

    constructor(extrato: Extrato<Transacao>, titulo: string) {
        this.extrato = extrato
        this.title = { text: titulo }
        this.operadoras = extrato
            ? extrato.agrupamentos.map(agrupamento => agrupamento.operadora)
            : []
        this.xAxis.categories = this.operadoras.map(operadora => operadora.nome)
        this.colors = this.operadoras.map(operadora => CORES_OPERADORAS[operadora.id])
        this.series = this.obterSeries()
    }

    abstract obterSeries(): { name: string; data: number[] }[]
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/vendas-recebimentos/shared/chart-periodo-options.ts